import { getLanguage } from '../../selectors/userSelectors';
import { EmmaBlueBanner } from '@axa-asia/emma-stylesheet';
import React from 'react';

export const EBDownloadBanner = () => {
  const lang = getLanguage();
  const downloadEmmaLink = `https://www.axa.com.hk/${lang}/emma-by-axa`;

  if (lang === 'zh') {
    return (
      <EmmaBlueBanner icon="functional/idea">
        {'現時此網上平台只供澳門團體醫療保單成員使用其e-康健卡。 請'}
        <a href={downloadEmmaLink} target="_blank" rel="noreferrer">
          下載
        </a>
        {'Emma by AXA 應用程式以享受更全面的電子服務。'}
      </EmmaBlueBanner>
    );
  }

  return (
    <EmmaBlueBanner icon="functional/idea">
      {
        'Currently this web portal only allows Macau Group Medical Policy members to access their eHealth Card. To access the full range of our digital services, please '
      }
      <a href={downloadEmmaLink} target="_blank" rel="noreferrer">
        download
      </a>
      {' Emma by AXA app.'}
    </EmmaBlueBanner>
  );
};
